/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Day3: 'Day3',
        AnotherDays: 'AnotherDays',
        Me: 'Me',
        Recommend: 'Recommend',
        Income: 'Income',
        RecommendBot: 'RecommendBot',
        RecommendButton: 'RecommendButton',
        LeftLittle: 'LeftLittle',
        RightLittle: 'RightLittle',
        NotLittle: 'NotLittle',
        DetailComment: 'DetailComment',
        DetailTitleLeft: 'DetailTitleLeft',
        DetailTitleRight: 'DetailTitleRight',
        DetailTitleSame: 'DetailTitleSame',
        DetailButtonProduct: 'DetailButtonProduct',
        DetailButtonOther: 'DetailButtonOther',
        SelectDate: 'SelectDate',
        MoreProduct: 'MoreProduct',
        MoreProductBot: 'MoreProductBot',
        ShowProduct: 'ShowProduct',
        MyInfo: 'MyInfo',        
        Total: 'Total',
        More: 'More',
        SaleAmount: 'SaleAmount',
        Cur: 'Cur',   // 현재 매출
        Total: 'Total', // 총 매출
        MySalesInfo: 'MySalesInfo',
        NotFound: 'NotFound',
        EditSale: 'EditSale',
        BothOver: 'BothOver',
        BothLess: 'BothLess',
        Not3Days: 'Not3Days',
        NeedMoreBoth: 'NeedMoreBoth',
    },
    tomy:{
        kr: {
            NeedMoreBoth: '양측 PV가 더 필요해요! ',
            Not3Days: '최근 3일간 하위매출이 없습니다.',
            MySalesInfo: '최근 1년간 최대 5건 조회가 가능합니다. 매출내역은 애터미 쇼핑몰에서 주문한 내역만 알려드립니다.',
            Day3: '{name}님, 최근 좌우 하위매출을 확인해보세요.',
            AnotherDays: '다른 일자의 소실적을 확인하려면 아래 버튼을 눌러보세요.',
            Me: '나의 매출내역',
            Recommend: '소실적 맞춤 상품 추천',
            Income: '수당내역',
            RecommendBot: '네, 추천 전 좌우 PV 균형이 맞는지 먼저 확인이 필요합니다. 일자를 선택해주시면 확인해드리겠습니다.',
            RecommendButton: '{month}월{date}일 PV 균형 확인',
            LeftLittle: '좌측 PV가 {pv}PV 부족합니다.',
            RightLittle: '우측 PV가 {pv}PV 부족합니다.',
            NotLittle: '좌우측 PV가 일치하네요',
            DetailComment: 'PV 맞춤 상품을 추천해드릴까요? 참고한 상품을 소실적 계정에서 구매한다면 균형을 맞출 수 있습니다.',
            DetailTitleLeft: '좌측 PV가 더 필요해요!',
            DetailTitleRight: '우측 PV가 더 필요해요!',
            DetailTitleSame: '좌우 PV의 균형이 맞네요. 다른 일자의 소실적을 확인하려면 아래 버튼을 눌러주세요.',
            DetailButtonProduct: 'PV 맞춤상품 추천받기',
            DetailButtonOther: '다른 일자 소실적 보기',
            SelectDate: '다른 일자 선택',
            MoreProduct: '추천상품 더보기',
            MoreProductBot: '추천 상품을 더 보여드리겠습니다.',
            ShowProduct: '{pv}PV이하의 상품을 보여드리겠습니다.',
            MyInfo: '챗봇에서는 1년 내 최근 5건까지 조회할 수 있습니다.',
            Total: '총 매출',
            More: '더 많은 매출내역 보기',
            SaleAmount: '주문수량: {num}개',
            NotFound: '{name}님, 최근 1년간 회원님의 매출이 존재하지 않습니다.',
            EditSale: '[주문내역 자세히 보기], [배송조회하기], [판매일자 변경하기]를 할수 있어요.',
            BothOver: '좌우 PV의 균형이 맞아, 수당이 발생하였습니다.',
            BothLess: '좌우 PV가 최소 300,000PV가 되어야 후원수당을 받을 수 있는 조건이 됩니다.',
        },
        eng: {
            NeedMoreBoth: 'Need more PV from both',
            Not3Days: 'No sub-sales in the last 3 days.',
            MySalesInfo: 'In the chatbot, you can search up to the 5 most recent cases within a year.',
            Day3: '{name}, Check the recent downliners sales.',
            AnotherDays: 'Please click the button below to check the results of other dates.',
            Me: 'My sales history',
            Recommend: 'Recommend products tailored to your needs',
            Income: 'Benefits',
            RecommendBot: 'Yes, it is necessary to check whether the left and right PV balances are correct before recommendation. Please select a date and we will check it.',
            RecommendButton: '{month}Month {date}Day PV Balance Check',
            LeftLittle: 'The PV on the left is less than the {pv} PV.',
            RightLittle: 'The PV on the right is less than the {pv} PV.',
            NotLittle: 'Left PV and right PV are the same!',
            DetailComment: 'Can you recommend PV customized products? If you buy the referenced product from your smaller leg account, you can balance it out.',
            DetailTitleLeft: 'I need more PV on the left!',
            DetailTitleRight: 'I need more PV on the right!',
            DetailTitleSame: 'The left and right PVs match. Please click the button below to check the results of other dates.',
            DetailButtonProduct: 'Get PV custom product recommendations',
            DetailButtonOther: 'View other date smaller leg',
            SelectDate: 'Choose a different date',
            MoreProduct: 'See more recommended products',
            MoreProductBot: 'We will show you more recommended products.',
            ShowProduct: 'We will show products with less than {pv} PV.',
            MyInfo: 'In the chatbot, you can search up to the last 5 cases within a year.',
            Total: 'Total sales',
            More: 'View more sales',
            SaleAmount: 'Quantity: +{num}',
            NotFound: '{name}, Recently, your sales have not existed for a year.',
            EditSale: 'You can [see order details], [see delivery details], and [change sales date].',
            BothOver: 'The balance of left and right PVs was right, so allowance occurred.',
            BothLess: 'Left and right PVs must be at least 300,000PV to be eligible for sponsorship.',
        },    
    },
    papa:{
        kr: {
            NeedMoreBoth: '양측 PV가 더 필요해요! ',
            Not3Days: '최근 3일간 하위매출이 없습니다.',
            MySalesInfo: '최근 1년간 최대 5건 조회가 가능합니다. 매출내역은 애터미 쇼핑몰에서 주문한 내역만 알려드립니다.',
            Day3: '{name}님, 최근 좌우 하위매출이에요.',
            AnotherDays: '다른 일자의 소실적을 확인하려면 아래 버튼을 눌러보세요.',
            Me: '나의 매출내역',
            Recommend: '소실적 맞춤 상품 추천',
            Income: '수당내역',
            RecommendBot: '소실적 상품 추천 전에, 각 일자별 좌우 PV 균형이 맞는지 먼저 확인해보세요.',
            RecommendButton: '{month}월{date}일 PV 균형 확인',
            LeftLittle: '좌측 PV가 {pv}PV 적네요.',
            RightLittle: '우측 PV가 {pv}PV 적네요.',
            NotLittle: '좌우측 PV가 일치하네요',
            DetailComment: '대신 PV 맞춤 상품을 준비했어요. 참고해서 소실적 계정에서 구매한다면 양쪽 균형이 맞겠네요.',
            DetailTitleLeft: '좌측 PV가 더 필요해요!',
            DetailTitleRight: '우측 PV가 더 필요해요!',
            DetailTitleSame: '좌우 PV가 일치하네요, 좋아요. 다른 일자의 소실적을 확인해볼까요?',
            DetailButtonProduct: 'PV 맞춤상품 추천받기',
            DetailButtonOther: '다른 일자 소실적 보기',
            SelectDate: '다른 일자 선택',
            MoreProduct: '추천상품 더보기',
            MoreProductBot: '추천 상품은 더 있답니다.',
            ShowProduct: '{pv}PV이하의 상품을 추천해줄게요.',
            MyInfo: '챗봇에서는 1년 내 최근 5건까지 조회할 수 있습니다.',
            Total: '총 매출',
            More: '더 많은 매출내역 보기',
            SaleAmount: '주문수량: +{num}개',
            NotFound: '{name}님, 최근 1년간 회원님의 매출이 존재하지 않습니다.',
            EditSale: '[주문내역 자세히 보기], [배송조회하기], [판매일자 변경하기]를 할수 있어요.',
            BothOver: '좌우 PV의 균형이 맞아, 수당이 발생하였습니다.',
            BothLess: '좌우 PV가 최소 300,000PV가 되어야 후원수당을 받을 수 있는 조건이 됩니다.',
        },
        eng: {
            NeedMoreBoth: 'Need more PV from both',
            Not3Days: 'No sub-sales in the last 3 days.',
            MySalesInfo: 'In the chatbot, you can search up to the 5 most recent cases within a year.',
            Day3: '{name}, Check the recent downliners sales.',
            AnotherDays: 'Please click the button below to check the results of other dates.',
            Me: 'My sales history',
            Recommend: 'Recommend products tailored to your needs',
            Income: 'Benefits',
            RecommendBot: 'Before recommending the smaller leg products, first check whether the left and right PV balance for each day is correct.',
            RecommendButton: '{month}Month {date}Day PV Balance Check',
            LeftLittle: 'The PV on the left is less than the {pv} PV.',
            RightLittle: 'The PV on the right is less than the {pv} PV.',
            NotLittle: 'Left PV and right PV are the same!',
            DetailComment: 'Instead, I prepared a PV customized product. As a reference, if you buy from a smaller leg account, both sides are right.',
            DetailTitleLeft: 'I need more PV on the left!',
            DetailTitleRight: 'I need more PV on the right!',
            DetailTitleSame: 'The left and right PVs match. Shall we check the smaller leg of another date?',
            DetailButtonProduct: 'Get PV custom product recommendations',
            DetailButtonOther: 'View other date smaller leg',
            SelectDate: 'Choose a different date',
            MoreProduct: 'See more recommended products',
            MoreProductBot: 'There are additional recommended products.',
            ShowProduct: 'I will recommend products with less than {pv} PV.',
            MyInfo: 'In the chatbot, you can search up to the last 5 cases within a year.',
            Total: 'Total sales',
            More: 'View more sales',
            SaleAmount: 'Quantity: +{num}',
            NotFound: '{name}, Recently, your sales have not existed for a year.',
            EditSale: 'You can [see order details], [see delivery details], and [change sales date].',
            BothOver: 'The balance of left and right PVs was right, so allowance occurred.',
            BothLess: 'Left and right PVs must be at least 300,000PV to be eligible for sponsorship.',
        },    
    },
};
